import React, { Component } from "react"; 
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../components/CustomComponent.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      amount: "0.00",
      amount_deposit: "0.00",
      total_pay: "0.00",
      transaction_list: []
    };
  }

  async componentDidMount() {
      loading(false);
      if(params("uid")){
        await this.Get(params("uid"));
        }
      window.print();
    }
  Get = async (uid) => {
        loading(true);
        let result = await GET("admin/repairs/list", { uid });
      if (result?.status) {
        const item = result.data;
        this.setState({
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name: item.customer?.full_name,
          customer_phone: item.customer?.phone,
          car_registration: item.car_registration,
          transaction_list: [...item.stock_activity_list.map(e=>e.transaction_list).flat(), ...item.transaction_list],
          amount: item.amount,
          amount_deposit: item.amount_deposit,
          total_pay: item.total_pay
        });
      }
      loading(false);
    };
    render() {
      const {document_no,created_at,customer_name,customer_phone,car_registration, transaction_list,amount,amount_deposit,total_pay} = this.state;
     return (
      <div className="mx-auto bg-white p-5 pdf" style={{ width: 1116, height: 1579 }}>
        <h2 className="fw-bold text-center mb-4">รายการซ่อม</h2>
        <h1 className="fw-bold text-center mb-3">ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่</h1>
        <h4 className="fw-bold text-center mb-3">61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่</h4>
        <h5 className="fw-bold text-center mb-3">โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060</h5>
        <div className="row mb-3">
          <div className="col-12"><h5 className="fw-bold mb-3">เลขที่เอกสาร : {document_no}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">วันที่ : {format_date(created_at,"dd mmmm yyyy", "th")}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">ทะเบียนรถ : {car_registration}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">ชื่อลูกค้า : {customer_name}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">เบอร์โทร : {customer_phone}</h5></div>
        </div>
        
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="fw-bold border-0">
              <td className="text-center border-1 wpx-70">ลำดับที่</td>
              <td className="text-start border-1">รายการ</td>
              <td className="text-center border-1 wpx-150">จำนวน</td>
              <td className="text-center border-1 wpx-150">ราคาต่อหน่วย</td>
              <td className="text-center border-1 wpx-150">ราคารวม</td>
            </tr>
          </thead>
          <tbody>
            {transaction_list.map((item, index)=>(
              <tr className="border-0">
                <td className="text-center border-1">{index + 1}</td>
                <td className="text-start border-1">{item.product_code} {item.product_name}</td>
                <td className="text-end border-1">{item.qty}</td>
                <td className="text-end border-1">{toFixed(item.unit_price)}</td>
                <td className="text-end border-1">{toFixed(Number(item.qty) * Number(item.unit_price))}</td>
              </tr>
            ))}
              <tr className="border-0">
                <td className="border-1"></td>
                <td className="fw-bold text-end border-1">ยอดรวมทั้งสิ้น</td>
                <td className="text-end border-1">{total(transaction_list,"qty")}</td>
                <td className="text-end border-1">{(() => {
                  let _total = 0;
                  transaction_list.forEach((tx) => {
                    _total += Number(tx.unit_price);
                  });
                  return toFixed(_total);
                })()}</td>
                <td className="text-end border-1">{(() => {
                  let _total = 0;
                  transaction_list.forEach((tx) => {
                    _total += Number(tx.unit_price) * Number(tx.qty);
                  });
                  return toFixed(_total);
                })()}</td>
              </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
